/* global google, genrus */
import haversine from 'haversine';
export default {
  init() {
    // JavaScript to be fired on the landing page

    // Grab postal code from user after they submit it.
    const postalcodeForm = document.getElementById('postalcodeForm');
    if(postalcodeForm) {
      postalcodeForm.addEventListener('submit', function(ev) {
        ev.preventDefault();
        getAddressByPostalCode();
        return false;
      });
    }

    // Check that if geolocation is available: if ("geolocation" in navigator) {}
    if ('geolocation' in navigator) {
      const geolocationButton = document.getElementById('geolocationButtonWrapper');
      if(geolocationButton) {
        geolocationButton.style.display = 'block';
      }
    }

    const getLocationButton = document.getElementById('getCurrentLocation');
    if(getLocationButton) {
      getLocationButton.addEventListener('click', function() {
        getLocationButton.innerHTML = 'Loading...';
        $('#status').html('');
        $('form input#postalcode').val('');
        navigator.geolocation.getCurrentPosition(
          function(position) {
            setLocation(position.coords);
            getLocationButton.innerHTML = 'Update your location';
          },
          function(error) {
            console.log('Geolocation Error:', error.code, error.message);
            $(getLocationButton).remove();
            $('#map_or_button').html('&nbsp;&nbsp;');
            $('#status').html('Unable to determine your location. Please try your postal code instead!');
          },
          {
            enableHighAccuracy: false,
            timeout: 1000 * 60,
            maximumAge: 1000 * 60 * 5,
          }
        );
      });
    }

    // Default center of map
    // Set center on middle of Canada
    const defaultlatlng = new google.maps.LatLng(53.8611552, -96.42749179999998);

    // Set up the map
    const map = new google.maps.Map(document.getElementById('map'), { zoom: 4, center: defaultlatlng });

    // Collect the markers for clearing later
    const markers = {};

    // Create single info window for reuse and only have single infowindow at once
    const infowindow = new google.maps.InfoWindow();

    //console.table(jsonLocations);

    // Setup the provider type filters
    const providerSelect = document.getElementById('providertype');
    let providerType = (providerSelect) ? providerSelect.value : 'all';
    if(providerSelect) {
      providerSelect.addEventListener('change', function() {
        providerType = this.value;
        toggleMarkers(providerType);
      });
    }



    // Separate markers into their categories (duplicate for ones with both)
    genrus.jsonLocations.forEach(function(location) {
      location.providerTypes.forEach(function(ptype) {
        if(providerType == 'all') {
          ptype = 'all';
        }
        let latlng = new google.maps.LatLng(location.lat, location.lng);
        let marker = new google.maps.Marker({
          position: latlng,
          title: location.address,
          icon: {
            url:genrus.pinURL,
          },
        });
        let buttonLink = ''
        if (location.landingPage) {
          buttonLink = location.landingPage
        } else {
          buttonLink = genrus.coveragePage
        }
        marker.customContent = `
        <div class="infoWindowContent">
          <div class="infoWindowContent__left">
            <img class="infoWindowContent__image" src="${location.thumbnail}" srcset="${location.thumbnail} 1x, ${location.thumbnailRetina} 2x" width="123" height="90" />
            <a href="https://www.google.com/maps/dir/?api=1&destination=${encodeURI(location.address)}" target="_blank" rel="noopener" class="infoWindowContent__directions">Get Directions</a>
          </div>
          <div class="infoWindowContent__right">
            <div class="infoWindowContent__title">
              ${location.title}
            </div>
            <div class="infoWindowContent__address">
              ${location.address}
            </div>
            `;
            if(location.phone) {
              marker.customContent += `
                <div class="infoWindowContent__phone">
                  ${location.phone}
                </div>
              `;
            }
            if(location.website) {
              marker.customContent += `
                <a href="${location.website}" class="infoWindowContent__website" target="_blank">Visit Website</a>
              `;
            }
            marker.customContent += `
            <a href="${buttonLink}" class="button button_green">See Coverage</a>
          </div>
        </div>
        `;
        marker.addListener('click', function() {
          infowindow.setContent(marker.customContent);
          infowindow.open(map, marker);
        });
        if(!markers[ptype]) {
          markers[ptype] = Array();
        }
        markers[ptype].push(marker);
      });
    });

    // Make sure only the currently toggled provider type markers are displaying
    function toggleMarkers(currentProviderType = 'pharmacy') {
      let boundcoords = Array();
      if(markers[currentProviderType]) {
        for(let markerlist in markers) {
          markers[markerlist].forEach(function(marker) {
            if(markerlist == currentProviderType) {
              boundcoords.push(marker.position);
              marker.setMap(map);
            } else {
              marker.setMap(null);
            }
          });
          map.setZoom(17);
        }
      }
      // Set the map to automatically zoom in to show all of the current markers
      let bounds = new google.maps.LatLngBounds();
      boundcoords.forEach(function(coords) {
        bounds.extend(coords);
      });
      map.fitBounds(bounds);

      if(boundcoords.length === 1) {
        map.setZoom(17);
      }
    }
    // Toggle the default markers
    toggleMarkers(providerType);

    // Get the current location coordinates and and update map position
    // const status = document.getElementById('status');
    function setLocation(coordinates) {
      let lat = coordinates.latitude, lng = coordinates.longitude;
      //console.log('coordinates', { lat, lng });
      // status.innerHTML = 'Debugging Information: Coordinates: ' + lat + ', ' + lng;
      map.setCenter({ lat, lng });
      // Set up the nearest marker to passed coordinates, whether through postal code or gps
      let nearDistance;
      let nearMarker;
      markers[providerType].forEach(function(marker) {
        let markerLat = marker.position.lat(), markerLng = marker.position.lng();
        // Find the nearest marker
        let currentDistance = haversine({ latitude:lat, longitude:lng }, { latitude:markerLat, longitude:markerLng }, {unit: 'km'})
        if(nearDistance) {
          if(currentDistance < nearDistance) {
            nearDistance = currentDistance;
            nearMarker = marker;
          }
        } else {
          nearDistance = currentDistance;
          nearMarker = marker;
        }
      });
      if(nearDistance <= 100) {
        let nearMarkerLat = nearMarker.position.lat(), nearMarkerLng = nearMarker.position.lng();
        map.setCenter({ lat:nearMarkerLat, lng:nearMarkerLng });
        map.setZoom(10);
      }
      else {

        if($('#marketing-page').val() === 'true') {
          $('#status').html('It looks like you are outside of the promoted area! Please <a href="/service-areas">check our services page</a> for a larger list of all our partners.');
        } else {
          $('#status').html('There are no Genrus Partners within 100kms of your location. We are always looking for new partners so please <a href="/contact">share your interest!</a>');
        }

        map.setCenter({ lat:lat, lng:lng });
        map.setZoom(6);
      }
    }

    const geocoder = new google.maps.Geocoder();
    function getAddressByPostalCode() {
      let postalcode = document.getElementById('postalcode').value;
      if(postalcode) {
        $('#status').html('');
        geocoder.geocode({ 'address': postalcode }, function(results, status) {
          if(status == 'OK') {
            document.getElementById('status').innerHTML = '';
            let postalLat = results[0].geometry.location.lat(), postalLng = results[0].geometry.location.lng();
            setLocation({ latitude:postalLat, longitude:postalLng });
          } else {
            document.getElementById('status').innerHTML = 'Sorry, this postal code does not exist.';
          }
        });
      }
    }
          
  },
  finalize() {
    // JavaScript to be fired on the landing page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/landing.js